var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRemoveFromCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.5C10.5 2.0875 10.1625 1.75 9.75 1.75H8.25V1H7.5V1.75H4.5V1H3.75V1.75H2.25C1.8375 1.75 1.5 2.0875 1.5 2.5V10C1.5 10.4125 1.8375 10.75 2.25 10.75H5.25V10H2.25V2.5H3.75V3.25H4.5V2.5H7.5V3.25H8.25V2.5H9.75V5.5H10.5V2.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8336 10.8033L9.24261 9.21231L10.8336 7.62132L10.3033 7.09099L8.71228 8.68198L7.12129 7.09099L6.59096 7.62132L8.18195 9.21231L6.59096 10.8033L7.12129 11.3336L8.71228 9.74264L10.3033 11.3336L10.8336 10.8033Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveFromCalendar);
export default __webpack_public_path__ + "static/media/ic-remove-from-calendar.ad916924d6a33f20618ccde14b2fb112.svg";
export { ForwardRef as ReactComponent };